import { makeAutoObservable, toJS } from "mobx";
import AppStore from "../stores/AppStore";

// Define the Qualification interface
export interface IQualification {
    id: string;
    uid: string;
    courseName: string; // Name of the course
    startDate: string; // Start date of the course
    endDate: string; // End date of the course
    certificateObtained: string; // Name of the certificate obtained
    institution: string; // Institution where the course was completed
    comments: string; // Additional comments or notes
    attachment:string[];
}

// Default Qualification object to use for initializing state
export const defaultQualification: IQualification = {
    id: "",
    uid: "",
    courseName: "",
    startDate: "",
    endDate: "",
    certificateObtained: "",
    institution: "",
    comments: "",
    attachment: []
};

// Define the Qualification class
export default class Qualification {
    private qualification: IQualification;

    constructor(private store: AppStore, qualification: IQualification) {
        makeAutoObservable(this);
        this.qualification = qualification;
    }

    get asJson(): IQualification {
        return toJS(this.qualification);
    }

    // Method to update course name
    updateCourseName(name: string) {
        this.qualification.courseName = name;
    }

    // Method to update start date
    updateStartDate(date: string) {
        this.qualification.startDate = date;
    }

    // Method to update end date
    updateEndDate(date: string) {
        this.qualification.endDate = date;
    }

    // Method to update certificate obtained
    updateCertificateObtained(certificate: string) {
        this.qualification.certificateObtained = certificate;
    }

    // Method to update institution
    updateInstitution(institution: string) {
        this.qualification.institution = institution;
    }

    // Method to update comments
    updateComments(comments: string) {
        this.qualification.comments = comments;
    }

    // Additional methods can be implemented as needed
}
